module.exports = __webpack_public_path__ + "media/night/143-263a02ec.svg";